<div class="login">
    
    <div class="container text-center mt-5 mb-5">
      <img src="../../../../assets/images/realdesk-logo.png">
    </div>

    <div class="container content-login">
      <div class="row">
        
        <div class="col-md-6">
          <img src="../../../../assets/images/ilustration_login.svg" class="img-fluid">
        </div>

        <div class="col-md-6 card">


        <h3 class="step-title text-center">Estamos criando sua conta</h3>
        <p class="step-description text-center mb-4">Geralmente é rápido, mas pode demorar alguns segundos</p>


          <form class="form" style="text-align: center;" >
            <img src="../../../../assets/images/skateboarding.gif" class="img-fluid mb-4" >
          </form>

          <!-- Texto de consentimento -->
        <div class="consent-text mt-4 text-center">
          <p>
            Ao enviar meus dados pessoais, autorizo a RealDesk a coletar, processar e armazenar minhas informações de acordo com o <a href="#" target="_blank">Aviso de Privacidade</a>, conforme descrito em <a href="#" target="_blank">Aviso de Privacidade da RealDesk</a>.
          </p>
        </div>
        </div>

      </div>
    </div>

      <!-- Links fixos no rodapé -->
  <footer class="footer mt-5 text-center">
    <p>&copy; RealDesk 2025</p>
    <a href="#" target="_blank">Aviso de Privacidade</a> | 
    <a href="#" target="_blank">Contrato Principal de Serviços</a>
  </footer>
</div>